export type UserAssetsState = Readonly<{
  loading: boolean;
  downloadingFile: string | null;
}>;

export const initialState: UserAssetsState = {
  loading: false,
  downloadingFile: null,
};
